(function() {
    var originalMoveForm = window.addComment.moveForm;

    window.addComment.moveForm = function( commId, parentId, respondId, postId, replyTo ) {
        // Create a temporary element right after the clicked reply link
        var replyLink = document.querySelector(
            '.' + 'comment-reply-link[data-commentid="' + parentId + '"]'
        );

        var tempAnchor = document.getElementById( '__temp-reply-anchor' );
        if ( tempAnchor ) {
            tempAnchor.parentNode.removeChild( tempAnchor );
        }

        if ( replyLink ) {
            tempAnchor = document.createElement( 'div' );
            tempAnchor.id = '__temp-reply-anchor';
            replyLink.parentNode.insertBefore( tempAnchor, replyLink.nextSibling );
            replyLink.style.display = 'none';
        }

        // Call original with our anchor's ID instead of commId
        return originalMoveForm.call( this, '__temp-reply-anchor', parentId, respondId, postId, replyTo );
    };

    var cancelLink = document.getElementById( 'cancel-comment-reply-link' );
    if ( cancelLink ) {
        var submitButton = document.getElementById( 'submit' );
        submitButton.parentNode.insertBefore( cancelLink, submitButton );

        cancelLink.addEventListener( 'click', function() {
            var tempAnchor = document.getElementById( '__temp-reply-anchor' );
            if ( tempAnchor ) {
                tempAnchor.parentNode.removeChild( tempAnchor );
            }

            var textarea = document.querySelector( '#commentform textarea' );
            if ( textarea ) {
                textarea.value = '';
            }

            document.querySelectorAll( '.comment-reply-link' ).forEach( function( link ) {
                link.style.display = '';
            } );
        });
    }

    // Grava cookie ao enviar formulário de comentário e apaga ao recarregar a página
    document.getElementById('commentform').addEventListener('submit', function() {
        document.cookie = 'bat_comment_submitted=true; path=/; max-age=60';
    });

    window.addEventListener('load', function() {
        if (document.cookie.split(';').some((item) => item.trim().startsWith('bat_comment_submitted='))) {
            document.cookie = 'bat_comment_submitted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }
    });
})();